import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useFirebaseAuth } from '../../../global/FirebaseProvider/FirebaseProvider';
import { ROUTE_MY_ACCOUNT } from '../../config/routes';
import { isTrashieMembershipPath } from '../../utils/routes';
import useNavigateWithSearch from '../../../../hooks/useNavigateWithSearch';

const TrashieMembershipContainer = ({ children }) => {
  const { isLoading, isSignedIn, userData } = useFirebaseAuth();
  const navigateWithSearch = useNavigateWithSearch();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isLoading && isSignedIn && userData?.email && isTrashieMembershipPath(pathname)) {
      if (!userData?.activeSubscription) {
        navigateWithSearch(ROUTE_MY_ACCOUNT);
      }
    }
  }, [isLoading, isSignedIn, userData, pathname]);

  if (isLoading || !isSignedIn || !isTrashieMembershipPath(pathname)) {
    return null;
  }

  return children;
};

export default TrashieMembershipContainer;
